/**
 * Estimación de participación en pool solo para perfiles sintetizados off-catalog.
 * Cuando la Market API devuelve el pool (`source: 'api'`), la UI debe usar
 * `token0SharePct` / `token1SharePct` del backend sin recalcular.
 */

export function parsePoolReserveAmount(reserve: string): number | null {
  const parsed = Number.parseFloat(reserve.replace(/[^0-9.eE+-]/g, ''))
  return Number.isFinite(parsed) ? parsed : null
}

export function parsePoolSpotRate(price: string): number | null {
  return parsePoolReserveAmount(price)
}

export function computePoolValueSharePct(
  reserves0: string,
  reserves1: string,
  price: string,
): { share0: string; share1: string; share0Num: number; share1Num: number } | null {
  const r0 = parsePoolReserveAmount(reserves0)
  const r1 = parsePoolReserveAmount(reserves1)
  const rate = parsePoolSpotRate(price)
  if (r0 == null || r1 == null || rate == null || rate <= 0) return null
  if (r0 === 0 && r1 === 0) return null

  const value0 = r0 * rate
  const value1 = r1
  const total = value0 + value1
  if (total <= 0) return null

  const pct0Raw = (value0 / total) * 100
  const pct0Num = Math.min(100, Math.max(0, Math.round(pct0Raw * 10) / 10))
  const pct1Num = Math.round((100 - pct0Num) * 10) / 10

  return {
    share0: `${pct0Num}%`,
    share1: `${pct1Num}%`,
    share0Num: pct0Num,
    share1Num: pct1Num,
  }
}
